import React from "react";

import { zIndexList } from "@vahak/core-ui/dist/constants";
import CrossIcon from "@vahak/core/dist/icons/close-grey.svg";

import AppImg from "../../utils/AppImg";
import { VahakAppDownloadLink } from "../../marketplace/common/share-modal/getLoadLorryShareUrl";
import Styles from "./DownloadAppQrModal.module.scss";

export const DOWNLOAD_APP_QR_MODAL = {
    qrImage: "qr_download_link.png",
    title: "Scan QR code to download app",
    defaultStoreUrl: VahakAppDownloadLink
} as const;

export interface DownloadAppQrModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    qrSrc?: string;
    qrSize?: number;
    overlayZIndex?: number;
}

const DownloadAppQrModal = ({
    isOpen,
    onClose,
    title = DOWNLOAD_APP_QR_MODAL.title,
    qrSrc = DOWNLOAD_APP_QR_MODAL.qrImage,
    qrSize = 220,
    overlayZIndex = zIndexList.modal + 100
}: DownloadAppQrModalProps) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className={Styles.overlay} style={{ zIndex: overlayZIndex }} onClick={onClose} role="presentation">
            <div
                className={Styles.dialog}
                onClick={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label={title}
            >
                <div className={Styles.card}>
                    <button type="button" className={Styles.closeBtn} onClick={onClose} aria-label="Close">
                        <CrossIcon />
                    </button>

                    <div className={Styles.content}>
                        <p className={Styles.title}>{title}</p>
                        <AppImg src={qrSrc} width={qrSize} height={qrSize} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadAppQrModal;
